// extracted by mini-css-extract-plugin
export var ctaHolder = "TestimonialSection-module--ctaHolder--d36fc";
export var innerWrapper = "TestimonialSection-module--innerWrapper--953b3";
export var intro = "TestimonialSection-module--intro--53cf6";
export var testimonialGroup = "TestimonialSection-module--testimonialGroup--3333d";
export var title = "TestimonialSection-module--title--fb52b";
export var wrapper = "TestimonialSection-module--wrapper--251eb";